/* eslint-disable import/order */
import { onboardingHubEntryPoint } from '@jira/admin-pages__onboarding-hub/src/onboardingHubEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { productsOnboardingHubRoute } from '@jira/router-routes__admin-pages-onboarding-hub-routes/src/productsOnboardingHubRoute.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { nav4SidebarGlobalProductsSettingsEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-products/src/nav4SidebarGlobalProductsSettingsEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

// When a user visits this page directly, the left sidebar comes from
// nav4SidebarGlobalProductsSettingsEntryPoint, but when they land on this page via
// the Global Settings Page Switcher, the left sidebar comes from the relay-resource-backed
// component: SidebarContentWithRelayResource.
// See @jira/navigation-apps__sidebar-nav4-sidebars-settings-global-products/src/ui/index.tsx.
const productsOnboardingHubWithDelegatedAdminEntryPoint = createPageEntryPoint({
	main: onboardingHubEntryPoint,
	leftSidebar: {
		sidebar: nav4SidebarGlobalProductsSettingsEntryPoint,
	},
});

export const productsOnboardingHubRouteEntry: Route = createEntry(
	productsOnboardingHubRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.products.onboarding-hub',
		meta: {
			reporting: {
				id: 'products-onboarding-hub',
				teamName: 'a4t-pandora',
				packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries',
			},
		},
		entryPoint() {
			if (fg('jira-onboarding-hub-gate')) {
				return productsOnboardingHubWithDelegatedAdminEntryPoint;
			}
			return undefined;
		},
		layout: globalSettingsLayout,
		navigation: {
			menuId: MenuIdSettings,
			sidebarId: SidebarIdGlobalProductsSettings,
		},
		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
